import React from 'react';
import { Card as MuiCard, CardProps, useTheme } from '@mui/material';

const SurfaceCard = React.forwardRef<HTMLDivElement, CardProps>(({ children, sx, ...rest }, ref) => {
  const theme = useTheme();
  return (
    <MuiCard
      ref={ref}
      elevation={3}
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: '1px solid rgba(255,255,255,0.04)',
        borderRadius: theme.shape?.borderRadius ?? 10,
        boxShadow: '0 8px 30px rgba(2,6,23,0.45)',
        padding: 0,
        WebkitBackgroundClip: 'padding-box',
        backgroundClip: 'padding-box',
        overflow: 'visible',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiCard>
  );
});

SurfaceCard.displayName = 'SurfaceCard';

export default SurfaceCard;
